import { Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

/** A short list of small records (links, recordings) edited inline: one row per item, fields as given. */
export const MetaListEditor = ({ items = [], fields, onChange, addLabel = "Legg til", emptyText, testId = "meta-list" }) => {
  const update = (i, k, v) => onChange(items.map((x, idx) => (idx === i ? { ...x, [k]: v } : x)));
  const remove = (i) => onChange(items.filter((_, idx) => idx !== i));
  const add = () => onChange([...items, Object.fromEntries(fields.map((f) => [f.key, ""]))]);
  return (
    <div className="space-y-2" data-testid={testId}>
      {items.length === 0 && emptyText && <p className="text-[13px] text-muted-foreground" data-testid={`${testId}-empty`}>{emptyText}</p>}
      {items.map((it, i) => (
        <div key={i} className="grid gap-2 rounded-lg border border-border bg-background/60 p-2.5 sm:grid-cols-[minmax(0,1fr)_auto]" data-testid={`${testId}-row-${i}`}>
          <div className="grid gap-2 sm:grid-cols-2">
            {fields.map((f) => (
              <Input key={f.key} value={it[f.key] || ""} onChange={(e) => update(i, f.key, e.target.value)} placeholder={f.placeholder} aria-label={f.label}
                inputMode={f.key === "url" ? "url" : undefined} className={f.wide ? "h-9 bg-background sm:col-span-2" : "h-9 bg-background"} data-testid={`${testId}-${i}-${f.key}`} />
            ))}
          </div>
          <Button type="button" variant="ghost" size="icon" className="h-9 w-9 self-start text-destructive hover:text-destructive" onClick={() => remove(i)} aria-label="Fjern" data-testid={`${testId}-${i}-remove`}><Trash2 className="h-4 w-4" /></Button>
        </div>
      ))}
      <Button type="button" variant="outline" size="sm" className="h-9 bg-card" onClick={add} data-testid={`${testId}-add`}><Plus className="h-4 w-4" /> {addLabel}</Button>
    </div>
  );
};
